export default {
  title: 'Serviciile noastre',
  consulting: {
    title: 'Consultanță',
    description: 'Asistență profesională în luarea deciziilor pe piața imobiliară.',
    more: 'Detalii',
  },
  ai_valuation: {
    title: 'Evaluare cu AI',
    description: 'Evaluare instantanee a valorii proprietății folosind algoritmi.',
    more: 'Află mai multe',
  },
  market_analytics: {
    title: 'Analiză de piață',
    description: 'Rapoarte periodice despre starea și tendințele pieței imobiliare.',
    more: 'Citește',
  },
  data_security: {
    title: 'Securitatea datelor',
    description: 'Metode moderne de stocare și procesare a informațiilor dvs.',
    more: 'Detalii',
  },
  automation: {
    title: 'Automatizare',
    description: 'Reducerea muncii manuale prin automatizarea proceselor.',
    more: 'Afișează',
  },
  internet_solutions: {
    title: 'Soluții internet',
    description: 'Integrare cu servicii digitale și IoT pentru case inteligente.',
    more: 'Află',
  }
}
